import React from 'react';
import { Filter } from 'lucide-react';
import { Form, FormField } from 'components/ui/form';
import { cn } from 'lib/utils';
import { useForm } from 'react-hook-form';
import { InputGs } from 'components/ui/Forms/inputGs';
import { customMask } from 'lib/customMask';
import { Button } from 'components/ui/ButtonGs';
import {
  useFilterStore,
  IFilterFields,
  usePaginationStore,
} from 'store/hub/hubDriver';
import { useQuery } from 'react-query';
import { useHubCarrier } from 'hooks/api';
import { SelectGs } from 'components/ui/Forms';

interface DataFilterProps {
  className?: string;
}

export const DataFilter: React.FC<DataFilterProps> = ({ className }) => {
  const [isOpened, setIsOpened] = React.useState<boolean>(false);
  const { filtersData, setFiltersData, clearFilters } = useFilterStore();
  const { pagination, setPagination } = usePaginationStore();
  const { fetchCarriers } = useHubCarrier();

  const form = useForm({
    defaultValues: filtersData,
  });

  const { data: carriers, isLoading: loadinDocTypes } = useQuery({
    queryKey: ['fetchCarriers'],
    queryFn: () => fetchCarriers(),
    staleTime: 1000 * 60 * 5, // 5 min,
    refetchOnWindowFocus: false,
  });

  const onFilter = (fields: IFilterFields) => {
    const cleanDocument = fields.document?.replace(/[^\d]/g, '') || '';
    setPagination({ ...pagination, page: 1 });
    setFiltersData({ ...fields, document: cleanDocument });
  };

  const handleClear = React.useCallback(() => {
    form.reset();
    clearFilters();
    setIsOpened(false);
  }, [clearFilters, form]);

  return (
    <div
      className={cn(
        'flex flex-col w-max rounded-md px-6 py-4 bg-white shadow-sm shadow-slate-300 duration-300 transition-all',
        className,
        isOpened && 'w-full'
      )}
    >
      <button
        onClick={() => {
          setIsOpened(!isOpened);
        }}
        className="group flex gap-2 items-center duration-300 transition-all"
      >
        <Filter
          className={cn(
            'cursor-pointer group-hover:fill-black transition-all duration-300',
            isOpened && 'fill-black'
          )}
          size={14}
        />
        <span className="text-slate-600 text-sm">Filtrar</span>
      </button>
      {isOpened && (
        <div id="filterForm" className="border-t-slate-300 border-t pt-3 mt-4 ">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onFilter)}>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <FormField
                  name="carrier_id"
                  control={form.control}
                  render={({ field }) => (
                    <SelectGs
                      {...field}
                      label={'Transportadora'}
                      onValueChange={(value: string) => {
                        field.onChange(value);
                      }}
                      content={carriers?.comboOptions || []}
                      isLoading={loadinDocTypes}
                      value={field.value ?? undefined}
                    />
                  )}
                />

                <FormField
                  name="document"
                  control={form.control}
                  render={({ field }) => (
                    <InputGs
                      {...field}
                      label="CPF"
                      value={field.value ?? ''}
                      onChange={(e) =>
                        field.onChange(
                          customMask(e.target.value, '999.999.999-99')
                        )
                      }
                    />
                  )}
                />
                <FormField
                  name="name"
                  control={form.control}
                  render={({ field }) => <InputGs {...field} label="Nome" />}
                />
                <FormField
                  name="phone_number"
                  control={form.control}
                  render={({ field }) => (
                    <InputGs
                      {...field}
                      label="Telefone"
                      value={field.value ?? ''}
                      onChange={(e) =>
                        field.onChange(
                          customMask(e.target.value, '(99) 99999-9999')
                        )
                      }
                    />
                  )}
                />
                {/* <FormField
                  name="email"
                  control={form.control}
                  render={({ field }) => (
                    <InputGs
                      {...field}
                      value={field.value ?? ''}
                      label="Email"
                    />
                  )}
                /> */}
              </div>
              <div className="flex justify-end w-full gap-4">
                <Button.Root
                  variant="secondary"
                  size="sm"
                  type="button"
                  onClick={handleClear}
                >
                  Limpar filtro
                </Button.Root>
                <Button.Root
                  variant="primary"
                  size="sm"
                  type="submit"
                  disabled={false}
                >
                  Buscar
                </Button.Root>
              </div>
            </form>
          </Form>
        </div>
      )}
    </div>
  );
};
